import React, { useState } from "react";
import { Grid, Box, AvatarGroup, Avatar } from "@mui/material";
import { farmers } from "../../config/images";
import translations from "../../config/language";
import ImageGallery from "../../components/ImageGallery/ImageGallery";

const FarmOwnershipDetails = ({ selectedFarmer }) => {
    const language = process.env.REACT_APP_LANGUAGE;

    const farmOwnerShip = selectedFarmer?.farm_ownership;
    const farmInfrastructureDetails = selectedFarmer?.infrastructure_details;
    const typesOfMachinery = selectedFarmer?.types_of_machinery;
    const trainingProgram = selectedFarmer?.training_program;
    const trainingProgramSponsors = selectedFarmer?.training_program_sponsor;
    const certificationsAndTraining = selectedFarmer?.certification_and_training;
    const otherTrainingPrograms = selectedFarmer?.other_training_programs;
    const otherTrainingProgramsSponsors = selectedFarmer?.other_training_sponsers;
    const otherCertifications = selectedFarmer?.other_certifications;

    const [images, setImages] = useState([]);
    const [imageIndex, setImageIndex] = useState("");
    const [galleryIsOpen, setGalleryIsOpen] = useState(false);

    function clampAvatars(avatars, maxVisible = 3) {
        const totalAvatars = avatars.length;
        const visibleAvatars = avatars.slice(0, maxVisible); // Show only 3
        const surplus = totalAvatars > maxVisible ? totalAvatars - maxVisible : 0; // Extra count

        return { avatars: visibleAvatars, surplus };
    }

    const handleGalleryOpen = (items, index) => {
        setGalleryIsOpen(true);
        setImages(items);
        setImageIndex(index);
    }

    return (
        <>
            <div className="user-profile" >
                {/* <Grid container>
                    <Grid item lg={4} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", paddingLeft: "20px" }}
                    >{translations[language].farmOwnership}
                    </Grid>
                    <Grid item lg={3} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", fontWeight: 700 }}>
                        {translations[language].owned}: {translations[language].titled}
                    </Grid>
                    <Grid item lg={5} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", fontWeight: 700 }}>
                        {translations[language].leased}: {translations[language].untitled}
                    </Grid>
                </Grid> */}
                <Grid container>
                    <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft: "20px" }}>{translations[language].infrastructureDetails}</Grid>
                </Grid>
                {farmInfrastructureDetails?.infrastructure_details?.map((infrastructure, index) => {
                    const { avatars, surplus } = clampAvatars(infrastructure.photos.map(photo => photo.photo), 3);
                    return (
                        <>
                            <Grid container>
                                <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>{infrastructure.infrastructure_type} {translations[language].ownership}</Grid>
                                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>
                                    {infrastructure.farm_ownership === 1 ? (
                                        `${translations[language].owned} : ${infrastructure.farm_ownership_type === 0 ? translations[language].titled : translations[language].untitled}`
                                    ) : (
                                        `${translations[language].leased}: ${infrastructure.farm_ownership_type === 0 ? translations[language].titled : translations[language].untitled}`
                                    )}
                                </Grid>
                                
                            </Grid>
                            <Grid container>
                                <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>{infrastructure.infrastructure_type}</Grid>
                                <Grid item lg={5} className="grid-item" style={{ fontWeight: 700 }}>{infrastructure.location}</Grid>
                                <Grid item lg={3} className="grid-item" style={{ fontWeight: 700, paddingBottom: "0px", paddingTop: "0px" }}>
                                    <div style={{ display: "flex", gap: "10px", fontWeight: 700, alignItems: "center"  }}>
                                        {infrastructure.hectors ?
                                            <div >{infrastructure.hectors} Hectors</div> :
                                            <div >{infrastructure.size} sq m</div>
                                        }
                                        <AvatarGroup sx={{ "--AvatarGroup-gap": "-16px" }}>
                                            {avatars.map((photo, i) => (
                                                <Avatar
                                                    key={i}
                                                    className="cursor-pointer"
                                                    style={{ cursor: "pointer" }}
                                                    sx={{ width: 35, height: 35 }}
                                                    onClick={() => handleGalleryOpen(infrastructure.photos.map(photo => photo.photo), i)}
                                                >
                                                    <img
                                                        src={photo || "/placeholder.svg"}
                                                        alt={`Attachment ${i + 1}`}
                                                        style={{
                                                            width: 35,
                                                            height: 35,
                                                            objectFit: "cover",
                                                        }}
                                                    />
                                                </Avatar>
                                            ))}
                                            {surplus > 0 && (
                                                <Avatar
                                                    sx={{
                                                        width: 35,
                                                        height: 35,
                                                        backgroundColor: "#3C4856",
                                                        color: "#FFFFFF",
                                                        fontSize: 14,
                                                        fontWeight: 400,
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => handleGalleryOpen(infrastructure.photos.map(photo => photo.photo), 3)} // start from 4th index as preview
                                                >
                                                    +{surplus}
                                                </Avatar>
                                            )}
                                        </AvatarGroup>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>{translations[language].accessToRoadAndDistance}</Grid>
                                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>
                                    {infrastructure.road_distance ?
                                        translations[language].available - infrastructure.road_distance :
                                        translations[language].notAvailable
                                    }
                                </Grid>
                            </Grid>
                        </>
                    )
                })}
                <Grid container >
                    <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft: "20px" }}>{translations[language].typesOfMachinery}</Grid>
                </Grid>
                {typesOfMachinery.map((machinery, index) => {
                    return (
                        <Grid container key={index}>
                            <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>
                                {machinery.types_of_machinery}
                            </Grid>
                            <Grid item lg={8} container className="grid-item" style={{ padding: "0px" }}>
                                {machinery?.farmer_machinery_equipment_type?.length > 0 ? (
                                    <Grid container spacing={1} style={{ margin: 0, width: '100%' }} >
                                        {machinery?.farmer_machinery_equipment_type?.map((submachinery, i) => (
                                            submachinery.farmer_machinery_equipment_subcategory?.map((subcategory, j) => {
                                                const isLastRowItem = Math.floor(j / 4) === Math.floor((submachinery.farmer_machinery_equipment_subcategory.length - 1) / 4);
                                                return (
                                                    <Grid
                                                        item
                                                        lg={3}
                                                        key={`${i}-${j}`}
                                                        style={{
                                                            fontWeight: 700,
                                                            padding: "10px 10px 10px 10px",
                                                            borderRight: "1px solid #D9D9D9",
                                                            borderBottom: !isLastRowItem ? "1px solid #D9D9D9" : "none"
                                                        }}
                                                    >
                                                        {subcategory.name}: {subcategory.quantity}
                                                    </Grid>
                                                );
                                            })
                                        ))}
                                    </Grid>
                                ) : (
                                    <Grid item style={{ fontWeight: 700, padding: "8px 16px" }}>
                                        N/A
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    );
                })}
                {/* Certification and Training */}
                <Grid container >
                    <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft: "20px" }}>{translations[language].certificationsAndTraining}</Grid>
                </Grid>
                <Grid container>
                    <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>
                        {translations[language].agriculturalCertifications}
                    </Grid>
                    <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>
                        {certificationsAndTraining?.map(certification => certification.name).join(", ") || "N/A"}
                    </Grid>
                </Grid>
                {otherCertifications?.length > 0 && (
                    <Grid container>
                        <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>
                            {translations[language].otherCertifications}
                        </Grid>
                        <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>
                            {otherCertifications?.map(certification => certification.name).join(", ") || "N/A"}
                        </Grid>
                    </Grid>
                )}
                {/* Training Programs */}
                <Grid container >
                    <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft: "20px" }}>{translations[language].trainingProgram}</Grid>
                </Grid>
                {trainingProgram?.training_program?.map((program, index) => {
                    return (
                        <Grid container>
                            <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>
                                {program.type_of_training_program}
                            </Grid>
                            <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>
                                {program?.training_program?.map(program => program.name).join(", ") || "N/A"}
                            </Grid>
                        </Grid>
                    )
                })}
                {otherTrainingPrograms?.length > 0 && (
                    <Grid container>
                        <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>
                            {translations[language].otherTrainingPrograms}
                        </Grid>
                        <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>
                            {otherTrainingPrograms?.map(program => program.name).join(", ") || "N/A"}
                        </Grid>
                    </Grid>
                )}
                {/* Who sponsors */}
                <Grid container >
                    <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft: "20px" }}>{translations[language].whoSponsoredTheTraining}</Grid>
                </Grid>
                {trainingProgramSponsors?.training_program_sponsor?.map((program, index) => {
                    return (
                        <Grid container>
                            <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>
                                {translations[language].sponsoredTraining}
                            </Grid>
                            <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>
                                {trainingProgramSponsors?.training_program_sponsor?.map(program => program.name).join(", ") || "N/A"}
                            </Grid>
                        </Grid>
                    )
                })}
                {otherTrainingProgramsSponsors?.length > 0 && (
                    <Grid container>
                        <Grid item lg={4} className="grid-item" style={{ paddingLeft: "20px" }}>
                            {translations[language].otherTrainingSponsors}
                        </Grid>
                        <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>
                            {otherTrainingProgramsSponsors?.map(program => program.name).join(", ") || "N/A"}
                        </Grid>
                    </Grid>
                )}

            </div>

            {galleryIsOpen &&
                <ImageGallery
                    images={images}
                    isOpen={galleryIsOpen}
                    onClose={() => setGalleryIsOpen(false)}
                    imageIndex={imageIndex}
                />

            }
        </>
    )
}

export default FarmOwnershipDetails;